import React from "react";
import styled from "styled-components";
import { SundayRunClubIcon } from "./icons/SundayRunClubIcon";

const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 34px;
  margin-bottom: 30px;
`;

const Logo = styled.a`
  height: 55px;
  width: 55px;
`;

const Line = styled.div`
  margin-bottom: 5px;
`;

const Accent = styled.span`
  font-size: 29px;
  font-weight: 400;
  color: "#434343";
  text-shadow: 0px 0px 4px rgb(255, 255, 255, 0.6);
  font-family: "Montserrat";
`;

const AppName = "PACE";
export const AppHeader = () => (
  <Header>
    <Logo href="/"> 
      <SundayRunClubIcon />
    </Logo>
    <Line>
      <Accent>{AppName}</Accent>
    </Line>
  </Header>
);
